import React, { useState } from "react";
import {Outlet, Link, useLocation } from "react-router-dom";
import './Leistungen.css';
import Footer from "../components/Footer";


{/** hier begins the change*/}
const leistungen = [
  {
    title: 'Fahrzeugaufbereitung',
    content: 'Professionelle Innen- und Außenreinigung inkl. Politur und Versiegelung.'
  },
  {
    title: 'Smart Repair',
    content: 'Kratzer, Dellen oder kleine Schäden schnell und günstig reparieren.'
  },
  {
    title: 'Reifenservice',
    content: 'Reifenwechsel, Einlagerung und neue Markenreifen zu Top-Konditionen.'
  },
  {
    title: 'Fahrzeugpflege & Aufbereitung',
    content: 'Tiefenreinigung für Innen- und Außenbereiche inklusive Lackpolitur, Kunststoffpflege und Versiegelung für dauerhaften Glanz.'
  },
  {
    title: 'Kleine Schäden? Kein Problem!',
    content: 'Kratzer, Dellen oder Lackschäden? Mit Smart Repair beheben wir Schönheitsfehler schnell, effektiv und kostengünstig.'
  },
  {
    title: 'Räderwechsel & Felgenservice',
    content: 'Reifenmontage, Wuchten und Felgenreparatur – alles aus einer Hand für Ihre Sicherheit und Komfort.'
  },
  {
    title: 'Reifeneinlagerung mit Komfort',
    content: 'Ihre Winter- oder Sommerreifen lagern wir fachgerecht, sauber und temperaturgerecht ein – ohne Schlepperei.'
  },
  {
    title: 'Wartung & Service für alle Fabrikate',
    content: 'Egal ob Audi, BMW oder Tesla – wir übernehmen die fachgerechte Inspektion und Wartung gemäß Herstellervorgaben.'
  },
  {
    title: 'Unfallschaden? Wir setzen es instand!',
    content: 'Karosserie- und Lackarbeiten nach Unfall – präzise, sicher und mit modernster Technik durchgeführt.'
  },
  {
    title: 'Klimaanlagen-Service',
    content: 'Reinigung, Wartung und Desinfektion Ihrer Klimaanlage – für saubere Luft und volle Leistung auch im Sommer.'
  },
  {
    title: 'Steinschlag? Glasservice vor Ort',
    content: 'Scheibenreparatur oder Austausch bei Glasbruch – schnell, zuverlässig und versicherungsfreundlich.'
  },
  {
    title: 'Haupt- & Abgasuntersuchung (HU/AU)',
    content: 'Wir bereiten Ihr Fahrzeug optimal vor und führen HU/AU durch – bequem direkt bei uns in der Werkstatt.'
  },
  {
    title: 'UVV-Prüfungen für Firmenfahrzeuge',
    content: 'Regelmäßige Prüfungen nach Unfallverhütungsvorschrift für Ihre gewerblich genutzten Fahrzeuge.'
  },
  {
    title: 'Fahrzeugumbauten & Individualisierung',
    content: 'Offroad-Umbauten, Sonderausstattungen oder Anpassungen für spezielle Einsatzzwecke – wir machen’s möglich.'
  },
  {
    title: 'US-Importe & Fahrzeuge',
    content: 'Importberatung, Umbauten auf EU-Norm, TÜV-Abnahme und Ersatzteilversorgung für amerikanische Fahrzeuge.'
  },
  {
    title: 'Präzise Achsvermessung',
    content: 'Moderne 3D-Achsmessgeräte garantieren Spurtreue, Fahrkomfort und gleichmäßigen Reifenabrieb.'
  },
  {
    title: 'Einrichtungen für Fahrzeuge & Transporter',
    content: 'Wir statten Nutzfahrzeuge mit Regalsystemen, Halterungen und individueller Einrichtung für Ihre Branche aus.'
  },
  {
    title: 'Express-Ersatzteile in Originalqualität',
    content: 'Top-Zulieferer sichern eine schnelle Lieferung von Ersatzteilen in Erstausrüsterqualität – oft noch am selben Tag.'
  },
  {
    title: 'Oldtimer & Youngtimer Betreuung',
    content: 'Sorgfältige Pflege, Wartung und Restaurierung klassischer Fahrzeuge – mit Liebe zum Detail und Erfahrung.'
  },
  {
    title: 'Getriebespülung & Ölwechsel',
    content: 'Moderne Spültechnik für Automatikgetriebe verlängert die Lebensdauer und sorgt für sanftes Schalten.'
  },
  {
    title: 'Fehlersuche mit Diagnosesystemen',
    content: 'Digitale Fehlerauslese und präzise Diagnose aller Fahrzeugsysteme mit modernstem Equipment.'
  },
  {
    title: 'Werkstattersatzwagen',
    content: 'Bleiben Sie mobil – bei längeren Reparaturen stellen wir Ihnen gern ein Ersatzfahrzeug zur Verfügung.'
  },
  {
    title: '24h-Fahrzeugannahme',
    content: 'Sie haben keine Zeit während der Öffnungszeiten? Nutzen Sie unsere flexible 24-Stunden-Annahmebox.'
  }
];
{/** hier ends the change*/}

const Leistungen = () => {

    const [isOpen, setIsOpen] = useState(false);
        
          const toggleMobileMenu = () => {
            setIsOpen(!isOpen);
          };

    {/** hier begins the change*/}
    const [activeIndex, setActiveIndex] = useState(null);

    const toggleIndex = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };
     {/** hier ends the change*/}

    return(
        <section className="container-leistungen"
        style={{ overflow: 'hidden'}}>
            <div className="navbar-leistungen"
                style={{
                position: 'relative',
                minHeight: '100%',
                width: '100%',
                backgroundImage: 'url(/assets/leistungen-hero.png)',
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
                zIndex: 0,
            }}
            >
                {/* Burger Button (mobile only) */}
                <div className="burger-button" onClick={toggleMobileMenu}>
                    <div className="bar"></div>
                    <div className="bar"></div>
                    <div className="bar"></div>
                </div>
    
                {/* Mobile Menu */}
                <nav className={`mobile-menu ${isOpen ? "open" : ""}`}>
                    <Link to="/überUns" onClick={toggleMobileMenu}>Über Uns</Link>
                    <Link to="/" onClick={toggleMobileMenu}>Home</Link>
                    <Link to="/aktuelles" onClick={toggleMobileMenu}>Aktuelles</Link>
                    <Link to="/kontakt" onClick={toggleMobileMenu}>Kontakt</Link>
                    <Link to="/impressum" onClick={toggleMobileMenu}>Impressum</Link>
                    <Link to="/datenschutz" onClick={toggleMobileMenu}>Datenschutz</Link>
                    <Link to="/blog" onClick={toggleMobileMenu}>Blog</Link>
                </nav>
    
                {/* Hexagon Nav (desktop) */}
                <section className="hero--inner">
                    <div className="hexagon-wrapper" id="hexagon-über-uns"><div className="hexagon"><i><Link to="/überUns" className="link">Über Uns</Link></i></div></div>
                    <div className="hexagon-wrapper" id="hexagon-leistungen"><div className="hexagon"><i><Link to="/" className="link">Home</Link></i></div></div>
                    <div className="hexagon-wrapper" id="hexagon-aktuelles"><div className="hexagon"><i><Link to="/aktuelles" className="link">Aktuelles</Link></i></div></div>
                    <div className="hexagon-wrapper" id="hexagon-kontakt"><div className="hexagon"><i><Link to="/kontakt" className="link">Kontakt</Link></i></div></div>
                    <div className="hexagon-wrapper" id="hexagon-impressum"><div className="hexagon"><i><Link to="/impressum" className="link">Impressum</Link></i></div></div>
                    <div className="hexagon-wrapper" id="hexagon-datenschutz"><div className="hexagon"><i><Link to="/datenschutz" className="link">Datenschutz</Link></i></div></div>
                    <div className="hexagon-wrapper" id="hexagon-blog"><div className="hexagon"><i><Link to="/blog" className="link">Blog</Link></i></div></div>
                </section>
            </div>

            <div
            style={{
                position: 'relative',
                minHeight: '100%',
                width: '100%',
                backgroundImage: 'url(/assets/leistungen-body.png)',
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
                zIndex: 0,
            }}>

                <div className="leistungen-container">
                <h1 className="leistungen-heading">Unsere Leistungen</h1>
                <p className="leistungen-intro">
                    Als meistergeführte Werkstatt in Wuppertal bieten wir Ihnen ein breites Leistungsspektrum – zuverlässig, transparent und fachgerecht.
                </p>


                {/** hier begins the change*/}
                <div className="leistungen-container">
                    <h1>Unsere Leistungen</h1>
                    {leistungen.map((item, index) => (
                        <div key={index} className="leistung-item">
                        <div className="leistung-header" onClick={() => toggleIndex(index)}>
                            <h2>{item.title}</h2>
                            <span className={`arrow ${activeIndex === index ? 'open' : ''}`}>&#9662;</span>
                        </div>
                        <div className={`leistung-content ${activeIndex === index ? 'visible' : ''}`}>
                            <p>{item.content}</p>
                        </div>
                        </div>
                    ))}
                </div>
                {/** hier ends the change*/}

                {/*<div className="leistungen-grid">
                    <div className="leistung-item">
                    <h2>Inspektion & Wartung</h2>
                    <p>Regelmäßige Checks nach Herstellervorgaben – für maximale Sicherheit und Werterhalt Ihres Fahrzeugs.</p>
                    </div>

                    <div className="leistung-item">
                    <h2>Fehlerdiagnose</h2>
                    <p>Moderne Diagnosetechnik zur schnellen Lokalisierung elektronischer und mechanischer Probleme.</p>
                    </div>

                    <div className="leistung-item">
                    <h2>Motor- & Getriebeservice</h2>
                    <p>Fachgerechte Reparatur und Wartung von Motor, Getriebe und Nebenaggregaten.</p>
                    </div>

                    <div className="leistung-item">
                    <h2>Bremsen & Fahrwerk</h2>
                    <p>Austausch und Instandsetzung von Bremsanlagen, Stoßdämpfern, Achsen und Fahrwerkskomponenten.</p>
                    </div>

                    <div className="leistung-item">
                    <h2>Klimaservice</h2>
                    <p>Reinigung, Desinfektion und Neubefüllung der Klimaanlage – für saubere und kühle Luft im Fahrzeug.</p>
                    </div>

                    <div className="leistung-item">
                    <h2>HU & AU Vorbereitung</h2>
                    <p>Vorab-Check und Durchführung der Haupt- und Abgasuntersuchung in Zusammenarbeit mit zertifizierten Prüfstellen.</p>
                    </div>
                </div>*/}
            </div>

        </div>
        <div className="footer-homepage">
        < Footer />
        </div>
            <Outlet />
        </section>
    );
};

export default Leistungen;

/**
 * <div class="hexagon-wrapper">
                <div class="hexagon" id="hexagon-über-uns">
                    <i class="fab-Über-Uns"><Link to="/überUns" class="link">Über Uns</Link></i>
                </div>
            </div>
            <div class="hexagon-wrapper" id="hexagon-leistungen">
                <div class="hexagon" >
                    <i class="fab-Leistungen"><Link to="/kontakt" class="link">Kontakt</Link></i>
                </div>
            </div>
            <div class="hexagon-wrapper" id="hexagon-aktuelles">
                <div class="hexagon">
                    <i class="fab-Aktuelles"><Link to="/aktuelles" class="link">Aktuelles</Link></i>
                </div>
            </div>
            <div class="hexagon-wrapper" id="hexagon-kontakt">
                <div class="hexagon">
                    <i class="fab-Kontakt"><Link to="/" class="link">Home</Link></i>
                </div>
            </div>
            <div class="hexagon-wrapper" id="hexagon-impressum">
                <div class="hexagon">
                    <i class="fab-Impressum"><Link to="/impressum" class="link">Impressum</Link></i>
                </div>
            </div>
            <div class="hexagon-wrapper" id="hexagon-datenschutz">
                <div class="hexagon">
                    <i class="fab-datenschutz"><Link to="/datenschutz" class="link">Datenschutz</Link></i>
                </div>
            </div>
            <div class="hexagon-wrapper" id="hexagon-blog">
                <div class="hexagon">
                    <i class="fab-blog"><Link to="/blog" class="link">Blog</Link></i>
                </div>
            </div>
 */